import React, { useEffect, useState } from 'react';

type Props = {
    country: any, 
    className: string,
    handlePhoneInputChange: (data: string) => void;
}

export default function PhoneNumberInput({ country, handlePhoneInputChange, className }: Props) {
    const [ phoneCode, setPhoneCode ] = useState('')
    const [ phone, setPhone ] = useState('');

    useEffect(() => {
        if (phone !== "") {
            handlePhoneInputChange(`${phoneCode}${phone}`);
        }
    }, [phone, phoneCode]);

    useEffect(() => {
        if (!country?.phone_code) {
            setPhoneCode("");
            return;
        }
        const codeWithSign = String(country.phone_code).includes("+")
            ? String(country.phone_code)
            : `+${country.phone_code}`;
        setPhoneCode(codeWithSign);
    }, [country]);

  const inputFieldStyle =
    className ||
    'w-full rounded-[16px] bg-ryd-gray px-[15px] py-[10px] pr-[26px] text-[14px] font-[400] leading-[26px] text-[#576877] outline-none';

  return (
    <div className={`${inputFieldStyle} flex min-w-0 items-center gap-x-2`}>
        <div className="shrink-0 whitespace-nowrap text-[13px] sm:text-[14px]">{phoneCode}</div>
        <input 
            type="tel" 
            placeholder='10 0112 233'
            pattern="[0-9]*"
            onChange={(e: any) => setPhone(e.target.value)}
            required={true} 
            className='min-w-0 w-full border-l border-[#E8E0EC] bg-transparent px-2 outline-0'
        />
    </div>
  )
}
